<template>
  <div class="fiche_horaire">
    <h1>Fiche Horaire</h1>
  </div>
</template>

<script>
  export default {
    name: 'FicheHoraire'
  }
</script>

<style scoped lang="scss">
  @import "../sass/variables";
  h1 {
    color: $firstcolor;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/FicheHoraire.vue